import React, { Component } from 'react';
import { Input } from '../atoms/Input';
import { FaUpload, FaEye } from 'react-icons/fa';

export class QuestionCommon extends Component {
  state = {
    showHintField: false,
    showUrlField: false,
    showImageField: false,
  };

  componentDidMount() {
    if (
      typeof this.props.hint === 'string' &&
      this.props.hint.trim().length > 0
    ) {
      this.setState({ showHintField: true });
    }
    if (
      typeof this.props.url === 'string' &&
      this.props.url.trim().length > 0
    ) {
      this.setState({ showUrlField: true });
    }
    if (
      (typeof this.props.mediaUrl === 'string' &&
        this.props.mediaUrl.trim().length > 0) ||
      this.props.preview
    ) {
      this.setState({ showImageField: true });
    }
  }

  componentDidUpdate(prevProps) {
    const prevHint = prevProps.hint ?? '';
    const currHint = this.props.hint ?? '';
    if (
      !this.state.showHintField &&
      prevHint !== currHint &&
      currHint.trim().length > 0
    ) {
      this.setState({ showHintField: true });
    }

    const prevUrl = prevProps.url ?? '';
    const currUrl = this.props.url ?? '';
    if (
      !this.state.showUrlField &&
      prevUrl !== currUrl &&
      currUrl.trim().length > 0
    ) {
      this.setState({ showUrlField: true });
    }

    const prevMediaUrl = prevProps.mediaUrl ?? '';
    const currMediaUrl = this.props.mediaUrl ?? '';
    if (
      !this.state.showImageField &&
      prevMediaUrl !== currMediaUrl &&
      currMediaUrl.trim().length > 0
    ) {
      this.setState({ showImageField: true });
    }
    if (!this.state.showImageField && !prevProps.preview && this.props.preview) {
      this.setState({ showImageField: true });
    }
  }

  handleShowUrlField = () => {
    this.setState({ showUrlField: true });
  };

  handleShowHintField = () => {
    this.setState({ showHintField: true });
  };

  handleShowImageField = () => {
    this.setState({ showImageField: true });
  };

  handleOpenUrl = () => {
    const rawUrl = (this.props.url ?? '').trim();
    if (!rawUrl) return;

    const normalizedUrl = /^https?:\/\//i.test(rawUrl)
      ? rawUrl
      : `https://${rawUrl}`;
    window.open(normalizedUrl, '_blank', 'noopener,noreferrer');
  };

  render() {
    const shouldShowHintField =
      this.state.showHintField ||
      (typeof this.props.hint === 'string' &&
        this.props.hint.trim().length > 0);
    const shouldShowUrlField =
      this.state.showUrlField ||
      (typeof this.props.url === 'string' &&
        this.props.url.trim().length > 0);
    const shouldShowImageField =
      this.state.showImageField ||
      (typeof this.props.mediaUrl === 'string' &&
        this.props.mediaUrl.trim().length > 0) ||
      this.props.preview;

    return (
      <>
        <div style={{ fontSize: '1rem', marginBottom: '0.8rem' }}>
          Ditt spørsmål *
        </div>
        <div className="question-prompt-question-row">
          <textarea
            className="question-prompt-textarea"
            maxLength={256}
            value={this.props.question}
            placeholder="Skriv inn ditt spørsmål her..."
            onChange={(e) =>
              this.props.handleQuestion(e.target.value)
            }
          />
        </div>

        <div className="question-prompt-hint-row">
          {shouldShowHintField ? (
            <Input
              maxLength={128}
              value={this.props.hint}
              placeholder="Hint:"
              description=""
              handler={this.props.handleHint}
              className="question-prompt-input"
              styleOverride={{ border: 'none', padding: '1rem' }}
            />
          ) : (
            <button
              type="button"
              className="question-prompt-add-link-button"
              onClick={this.handleShowHintField}
            >
              Legg til hint
            </button>
          )}
          {shouldShowUrlField ? (
            <div className="question-prompt-url-row question-prompt-input">
              <Input
                maxLength={1024}
                value={this.props.url}
                placeholder="Lenke (URL):"
                description=""
                handler={this.props.handleUrl}
                className="question-prompt-input"
                styleOverride={{ border: 'none', padding: '1rem' }}
              />
              {(this.props.url ?? '').trim().length > 0 ? (
                <button
                  type="button"
                  className="question-prompt-open-link-button"
                  onClick={this.handleOpenUrl}
                  title="Åpne lenke i ny fane"
                >
                  <FaEye />
                </button>
              ) : null}
            </div>
          ) : (
            <button
              type="button"
              className="question-prompt-add-link-button"
              onClick={this.handleShowUrlField}
            >
              Legg til lenke
            </button>
          )}
          {shouldShowImageField ? (
            <>
              <input
                type="file"
                className="file-input-hidden"
                id="question-image-upload"
                accept="image/*"
                onChange={(e) =>
                  this.props.handleFileChange(e.target.files)
                }
              />
              <div style={{ color: 'rgba(103, 107, 133, 0.45)', paddingTop: '1rem' }}>
                <label
                  style={{}}
                  className="question-prompt-upload-button"
                  htmlFor="question-image-upload"
                >
                  Last opp bilde{' '}
                  <FaUpload style={{ marginLeft: '1.0rem', height: '1.0rem', width: '1.0rem' }}/>
                </label>
                  <span style={{ color: 'rgba(103, 107, 133, 0.45)', fontSize: '0.8rem' }}>
                    Anbefalt størrelse er 500x500 piksler
                  </span>
                <div
                  style={{
                    marginTop: '.2em',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                </div>
              </div>
            </>
          ) : (
            <button
              type="button"
              className="question-prompt-add-link-button"
              onClick={this.handleShowImageField}
            >
              Legg til bilde
            </button>
          )}
        </div>
        <div
          style={{
            marginBottom: '1em',
            display: 'flex',
            alignContent: 'center',
          }}
        >
          {this.props.mediaUrl.length > 0 ? (
            <>
            <img
              src={this.props.mediaUrl}
              style={{
                width: 'auto',
                maxWidth: '45%',
                height: 'auto',
                maxHeight: '100px',
                borderRadius: '.3em',
                margin: ' auto 1em auto 0',
              }}
              alt="Opplastet bilde"
            />
            <div><div onClick={this.props.removeImage} className="btn" style={{ padding: '5px 10px'}}>Fjern bilde</div></div>
            </>
          ) : null}
          {this.props.preview ? (
            <img
              src={this.props.preview}
              style={{
                width: 'auto',
                maxWidth: '45%',
                height: 'auto',
                maxHeight: '100px',
                borderRadius: '.3em',
                margin: ' auto 0',
              }}
              alt="Forhåndsvisning"
            />
          ) : null}
        </div>
      </>
    );
  }
}

export default QuestionCommon;
